import { usePermission } from 'app/services';
import React from 'react';
const Protect = (props) => {
    const { permissions, renderPermitted, renderForbidden } = props;
    const permitted = usePermission(permissions);
    return React.createElement(React.Fragment, null, permitted ? renderPermitted() : renderForbidden());
};
export default Protect;
